export enum UserRole {
  admin = "ADMIN",
  editor = "EDITOR",
  god = "GOD",
}
